// Số user «KHÔNG GIỚI HẠN» của gói — bản FE của `planService.UNLIMITED_SEATS` (Work api/src/services/planService.js).
//
// Gói dùng thử 14 ngày mở không giới hạn user (sếp Phú 19/10/2026). BE giữ một SỐ THẬT (999999) trên dòng license
// để mọi cửa đếm ghế tự thông, và trả kèm cờ `seats_unlimited` ở /users/seat-status, /auth/me/tenant-seat-status,
// /platform/tenants/:id/state. Chỗ IN con số hỏi hàm này — đừng in thẳng `quota` ra «3/999999», đừng tính thanh
// phần trăm trên mẫu số đó (luôn ~0% trông như «gói gần trống»).
//
// Nhận cả payload (đọc cờ `seats_unlimited`, lùi về `quota`) lẫn con số trần — payload Core chuyển tiếp
// (`seats: { quota, … }`) không mang cờ.

export const UNLIMITED_SEATS = 999999;

/**
 * @param {number|string|{seats_unlimited?: boolean, quota?: number}|null|undefined} v
 * @returns {boolean}
 */
export function isUnlimitedSeats(v) {
  if (v == null) return false;
  if (typeof v === 'object') return v.seats_unlimited === true || Number(v.quota) >= UNLIMITED_SEATS;
  return Number(v) >= UNLIMITED_SEATS;
}
